const baseURL = "https://api.fortcore.trusoft.ng/parse";
export const walletApi = "https://api.fortcoretech.com/api";

export default baseURL;
